import { useContext } from 'react';
import { StatTile, StatTileEmpty } from '@/components/ui/stat-tile';
import AuthContext from '../../../../contexts/auth';
import { translate } from "../../../../utils/Common";

// paquetes retirados en el año actual
const PackagesPickUpLastYear = ({ cantPackagesPickUpLastYear }) => {
    const userContext = useContext(AuthContext);
    const isProvider = userContext.user?.IdTipoUsuario === 1;

    if (!(cantPackagesPickUpLastYear || cantPackagesPickUpLastYear === 0)) return <StatTile loading />;
    if (cantPackagesPickUpLastYear === 0) {
        return <StatTileEmpty label={translate("dashboard.home.packages_pick_up_lastyear")} />;
    }

    const verb = isProvider
        ? translate("dashboard.home.packages_pick_up_lastyear.packages.delivered")
        : translate("dashboard.home.packages_pick_up_lastyear.packages.retired");

    return (
        <StatTile
            value={cantPackagesPickUpLastYear}
            label={`${verb} ${translate("dashboard.home.packages_pick_up_lastyear.packages.in_this_year")}`}
            info={`${translate("dashboard.home.packages_pick_up_lastyear.info.indicator")} ${
                isProvider
                    ? translate("dashboard.home.packages_pick_up_lastyear.info.delivered")
                    : translate("dashboard.home.packages_pick_up_lastyear.info.retired")
            } ${translate("dashboard.home.packages_pick_up_lastyear.info.in_this_year")}`}
        />
    );
};

export default PackagesPickUpLastYear;
